var _rect, _rect2, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCautionIconRounded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#FFCDCE"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 32,
    height: 32,
    rx: 16,
    stroke: "#FFE6E7",
    strokeWidth: 5.33333
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 20.8333C18.7267 20.8333 18.5 20.6067 18.5 20.3333V17C18.5 16.7267 18.7267 16.5 19 16.5C19.2733 16.5 19.5 16.7267 19.5 17V20.3333C19.5 20.6067 19.2733 20.8333 19 20.8333Z",
    fill: "#EF4444"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9999 23C18.9599 23 18.9133 22.9934 18.8666 22.9867C18.8266 22.98 18.7866 22.9667 18.7466 22.9467C18.7066 22.9334 18.6666 22.9134 18.6266 22.8867C18.5933 22.86 18.5599 22.8334 18.5266 22.8067C18.4066 22.68 18.3333 22.5067 18.3333 22.3334C18.3333 22.16 18.4066 21.9867 18.5266 21.86C18.5599 21.8334 18.5933 21.8067 18.6266 21.78C18.6666 21.7534 18.7066 21.7334 18.7466 21.72C18.7866 21.7 18.8266 21.6867 18.8666 21.68C18.9533 21.66 19.0466 21.66 19.1266 21.68C19.1733 21.6867 19.2133 21.7 19.2533 21.72C19.2933 21.7334 19.3333 21.7534 19.3733 21.78C19.4066 21.8067 19.4399 21.8334 19.4733 21.86C19.5933 21.9867 19.6666 22.16 19.6666 22.3334C19.6666 22.5067 19.5933 22.68 19.4733 22.8067C19.4399 22.8334 19.4066 22.86 19.3733 22.8867C19.3333 22.9134 19.2933 22.9334 19.2533 22.9467C19.2133 22.9667 19.1733 22.98 19.1266 22.9867C19.0866 22.9934 19.0399 23 18.9999 23Z",
    fill: "#EF4444"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0402 25.7732H14.9602C13.6602 25.7732 12.6669 25.2999 12.1602 24.4466C11.6602 23.5932 11.7269 22.4932 12.3602 21.3532L16.4002 14.0866C17.0669 12.8866 17.9869 12.2266 19.0002 12.2266C20.0136 12.2266 20.9336 12.8866 21.6002 14.0866L25.6402 21.3599C26.2736 22.4999 26.3469 23.5932 25.8402 24.4532C25.3336 25.2999 24.3402 25.7732 23.0402 25.7732ZM19.0002 13.2266C18.3736 13.2266 17.7602 13.7066 17.2736 14.5732L13.2402 21.8466C12.7869 22.6599 12.7136 23.4066 13.0269 23.9466C13.3402 24.4866 14.0336 24.7799 14.9669 24.7799H23.0469C23.9802 24.7799 24.6669 24.4866 24.9869 23.9466C25.3069 23.4066 25.2269 22.6666 24.7736 21.8466L20.7269 14.5732C20.2402 13.7066 19.6269 13.2266 19.0002 13.2266Z",
    fill: "#EF4444"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCautionIconRounded);
export default __webpack_public_path__ + "static/media/caution-icon-rounded.b0d3ced3166694ff6155994bf1cd13d5.svg";
export { ForwardRef as ReactComponent };